import { ProblemType } from '@/static/enums/problemType';
import { ProblemTarget } from '@/static/enums/problemTarget';

/**
 * Map of values against which system the problem is specific to or if
 * problem is not specific to a single system.
 */
export const ProblemTypeToTarget: Record<ProblemType, ProblemTarget> = {
  [ProblemType.VALIDATION_ERRORS]: ProblemTarget.OVERALL,
  [ProblemType.NOT_OPENED_IN_TARN]: ProblemTarget.ETIS,
  [ProblemType.NOT_IN_SYNC_WITH_TARN]: ProblemTarget.ETIS,
  [ProblemType.NOT_NOT_CLOSED_IN_TARN]: ProblemTarget.ETIS,
  [ProblemType.NOT_NOT_REOPENED_IN_TARN]: ProblemTarget.ETIS,
  [ProblemType.NOT_NOT_PARTIALLY_CLOSED_IN_TARN]: ProblemTarget.ETIS,
  [ProblemType.NOT_NOT_STOPPED_IN_TARN]: ProblemTarget.ETIS,
  [ProblemType.NOT_NOT_UNSTOPPED_IN_TARN]: ProblemTarget.ETIS,
  [ProblemType.NOT_IN_SYNC_WITH_TR_OPENED]: ProblemTarget.TR,
  [ProblemType.NOT_IN_SYNC_WITH_TR_CLOSED]: ProblemTarget.TR,
  [ProblemType.NOT_IN_SYNC_WITH_TR_OTHER]: ProblemTarget.TR,
};
